import { Bold, Icons } from "@serodigital/ui-components";
import * as React from "react";

export function ScheduleDeleteButton({ onClick }) {
	return (
		<div data-qa="delete-schedule" className="flex justify-center pt-16">
			{/* rome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
			<span data-qa="delete-schedule-button" onClick={onClick} className="flex cursor-pointer space-x-8">
				<Icons.TrashCan width={24} height={24} /> <Bold>Delete Schedule</Bold>
			</span>
		</div>
	);
}
